var map = {
	"./About/JrMeet.jpg": 1043,
	"./About/correspondent1.jpg": 101,
	"./About/montoring-1.jpg": 4981,
	"./About/plcsnrjr.jpg": 2808,
	"./About/principa.jpg": 2344,
	"./About/staffawards/ta1.jpg": 1171,
	"./About/staffawards/ta10.jpg": 3131,
	"./About/staffawards/ta11.jpg": 2974,
	"./About/staffawards/ta12.jpg": 4473,
	"./About/staffawards/ta13.jpg": 6684,
	"./About/staffawards/ta14.jpg": 6919,
	"./About/staffawards/ta15.jpg": 8634,
	"./About/staffawards/ta16.jpg": 2213,
	"./About/staffawards/ta17.jpg": 8248,
	"./About/staffawards/ta18.jpg": 7987,
	"./About/staffawards/ta19.jpg": 3222,
	"./About/staffawards/ta2.jpg": 1460,
	"./About/staffawards/ta20.jpg": 2822,
	"./About/staffawards/ta21.jpg": 4435,
	"./About/staffawards/ta22.jpg": 4388,
	"./About/staffawards/ta23.jpg": 2433,
	"./About/staffawards/ta24.jpeg": 2271,
	"./About/staffawards/ta25.jpeg": 3752,
	"./About/staffawards/ta26.jpg": 4128,
	"./About/staffawards/ta27.jpeg": 8002,
	"./About/staffawards/ta28.jpg": 1950,
	"./About/staffawards/ta29.jpg": 6907,
	"./About/staffawards/ta3.jpg": 3265,
	"./About/staffawards/ta30.jpg": 2125,
	"./About/staffawards/ta31.jpg": 3552,
	"./About/staffawards/ta32.jpg": 7903,
	"./About/staffawards/ta33.jpeg": 7775,
	"./About/staffawards/ta34.jpeg": 7590,
	"./About/staffawards/ta35.jpg": 116,
	"./About/staffawards/ta36.jpg": 6179,
	"./About/staffawards/ta37.jpg": 6694,
	"./About/staffawards/ta38.jpeg": 8522,
	"./About/staffawards/ta39.jpg": 1720,
	"./About/staffawards/ta4.jpg": 8034,
	"./About/staffawards/ta40.jpg": 3008,
	"./About/staffawards/ta41.jpg": 109,
	"./About/staffawards/ta5.jpg": 9743,
	"./About/staffawards/ta6.jpg": 2368,
	"./About/staffawards/ta7.jpg": 7261,
	"./About/staffawards/ta8.jpg": 2254,
	"./About/staffawards/ta9.jpg": 6651,
	"./About/staffgroup.jpg": 797,
	"./About/withoutu1.jpeg": 2391,
	"./AnnualDay/1.jpg": 8707,
	"./AnnualDay/122.JPG": 7808,
	"./AnnualDay/131.JPG": 140,
	"./AnnualDay/266.JPG": 7219,
	"./AnnualDay/270.JPG": 8582,
	"./AnnualDay/273.JPG": 4865,
	"./AnnualDay/279.JPG": 1291,
	"./AnnualDay/280.JPG": 1799,
	"./AnnualDay/30.jpg": 8973,
	"./AnnualDay/317.JPG": 8754,
	"./AnnualDay/321.JPG": 6797,
	"./AnnualDay/325.JPG": 7105,
	"./AnnualDay/329.JPG": 9829,
	"./AnnualDay/331.JPG": 7778,
	"./AnnualDay/34.JPG": 2692,
	"./AnnualDay/368.JPG": 8628,
	"./AnnualDay/377.JPG": 5384,
	"./AnnualDay/38.JPG": 1768,
	"./AnnualDay/39.jpg": 2536,
	"./AnnualDay/42.JPG": 943,
	"./AnnualDay/46.jpg": 1814,
	"./AnnualDay/50.jpg": 543,
	"./AnnualDay/57.JPG": 5485,
	"./AnnualDay/61.JPG": 2510,
	"./AnnualDay/69.JPG": 3206,
	"./AnnualDay/7.JPG": 9606,
	"./AnnualDay/74.jpg": 9437,
	"./AnnualDay/9.JPG": 7912,
	"./Christmas/02.JPG": 4412,
	"./Christmas/03.JPG": 8585,
	"./Christmas/04.JPG": 442,
	"./Christmas/05.JPG": 7303,
	"./Christmas/07.JPG": 2789,
	"./Christmas/46.JPG": 4260,
	"./Christmas/51.JPG": 252,
	"./Christmas/55.JPG": 9336,
	"./Christmas/SSS_7452.JPG": 426,
	"./Christmas/SSS_7483.JPG": 6972,
	"./Christmas/SSS_7537.JPG": 6704,
	"./Facilities/fac-1.jpg": 2634,
	"./Facilities/fac-2.jpg": 9861,
	"./Facilities/fac-3.jpg": 3515,
	"./Gendral/1.jpeg": 786,
	"./Gendral/2.jpeg": 5567,
	"./Labs/biolab1.jpeg": 7918,
	"./Labs/biolab2.jpeg": 2315,
	"./Labs/chelab1.jpeg": 8654,
	"./Labs/chelab2.jpeg": 9963,
	"./Labs/childlab1.jpg": 653,
	"./Labs/childlab2.jpg": 754,
	"./Labs/cslab3.jpg": 4895,
	"./Labs/cslab5.jpg": 2113,
	"./Labs/language1.jpg": 1246,
	"./Labs/lib1.jpeg": 5300,
	"./Labs/phylab1.jpeg": 9032,
	"./Labs/phylab2.jpeg": 6382,
	"./Logo/logo.png": 9951,
	"./Sports/football-1.jpg": 339,
	"./Sports/hockey-1.jpg": 2647,
	"./Sports/hockey-2.jpg": 5192,
	"./Sports/volly-1.jpg": 4300,
	"./Toppers/10-1.png": 765,
	"./Toppers/10-2.png": 9558,
	"./Toppers/11-1.png": 5840,
	"./Toppers/11-2.png": 9659,
	"./Toppers/11-3.png": 9154,
	"./Toppers/12-1.png": 6803,
	"./Toppers/12-2.png": 1528,
	"./Toppers/12-3.png": 9393,
	"./Toppers/12-4.png": 8382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;